import { render } from "./ModalItemUnavailable.vue?vue&type=template&id=5c1a63de"
import script from "./ModalItemUnavailable.vue?vue&type=script&lang=js"
export * from "./ModalItemUnavailable.vue?vue&type=script&lang=js"

import exportComponent from "/media/dev/Develop/Projects/Sjef/kiosk.sjef.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__